import { Divider, Typography, Grid, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import { connect } from "react-redux";
import { getLeaderboard, updateHeaderInfo, copyDeck, subscribeDeck, getUserDetails, updateNotification, getMessages } from "../actions";
import { LoadingCard, CopyrightWidget } from "../components";
import { deviceData, getThisYear, scrollTop } from "../common";
import { isBrowser } from 'react-device-detect';

class NotificationsClass extends Component {
    state = {
        loading: true,
        messages: []
    }

    componentDidMount = async () => {
        const { mcid, key } = this.props.auth_feedback;

        await this.props.getMessages({mcid: mcid, key: key})
        await this.props.getUserDetails(mcid, key, deviceData(this.props.location, 'navigate'));
        // this.setState({ ...this.state, loading: false})
       
        return this.props.updateHeaderInfo({
            route:"/notifications", 
            name: "Notifications", 
            iconTwo: 'menu',
            iconOne: 'home',
        });
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (this.state.loading) {
            this.setState({ ...this.state, loading: false});
        }

        if (prevProps.messages !== this.props.messages) {
            this.setState({ ...this.state, messages: this.props.messages })
        }

        // if (prevProps.user_details !== this.props.user_details) {
        //     scrollTop('TargetDIV', 0);
        //     this.setState({ ...this.state, loading: false});
        // }

        if (prevState.messages !== this.state.messages) {
            this.setState({ ...this.state, loading: false })
        }
    }

    createMarkup = props => {
        if (!props.includes('<p>')) { props = '<p>' + props + '</p>'}
        return { __html: props };
    };

    updateDeck = async (data) => {
        this.setState({ ...this.state, loading: true});
        let notif = {
            mcid : data.mcid,
            key : data.key,
            state : data.state,
            pkid : data.pkid
        };

        let obj = {
            mcid : data.mcid,
            key : data.key,
            deckID : data.deckId
        };

        await this.props.updateNotification(notif);
        switch(data.type) {
            case 'copy': {
                await this.props.copyDeck(obj);
                await this.props.getUserDetails(obj.mcid, obj.key);
                this.props.history.push('/myDecks');
                break;
            }
            case 'subscribe': {
                await this.props.subscribeDeck(obj);
                await this.props.getUserDetails(obj.mcid, obj.key);
                this.props.history.push('/myDecks');
                break;
            }

            default: {
                await this.props.getUserDetails(obj.mcid, obj.key);
                break;
            }
        }
    }

    mapNotificationsToList = () => {
        // const notifs = this.props.user_details.notifications.notifications.filter( i => i.notificationType != 'GEN');
        const notifs = this.state.messages.notifications;
        if (typeof notifs !== 'undefined' && notifs.length > 0) {
            return notifs.map((item, index) => {
                let className = 'text-blue';
                let primary = item.summary;
                let secondary = item.datestr;
                if (item.notificationState === 1) { className += ' text-strong' } 
                return (
                    <>
                        <ListItem
                            className="flex-row-between width100"
                        >
                            <Link
                                to={{
                                    pathname: "/viewMessage",
                                    deckID: item.notificationDetail,
                                    pkid: item.pkid,
                                }}
                                className={className}
                            >
                                <ListItemText 
                                    primary={primary}
                                    secondary={secondary}
                                    className={className}
                                    
                                />
                            </Link>
                            <ListItemIcon className="" style={{justifyContent: "flex-end"}}>
                                <CloseIcon
                                    onClick={() => this.updateDeck({
                                        mcid: this.props.user_details.mcid,
                                        key: this.props.user_details.key,
                                        deckId: item.notificationDetail,
                                        pkid: item.pkid,
                                        state: 0,
                                        type: 'delete'
                                    })}
                                    className="text-orange"
                                    style={{ 
                                        fontSize: '1.5em',
                                        justifyContent: "flex-end",
                                        marginTop: "2px"
                                    }}
                                />
                            </ListItemIcon>
                        </ListItem>
                        <Divider />
                    </>
                )
            });
        } else {
            return (
                <>
                    <ListItemText 
                        primary="No Messages"
                        secondary=""
                        style={{padding: "0", fontSize: "1.25em", fontWeight: "700"}}
                    />
                </>
            ); 
        }
    }

    setContainer = (bool) => {
        return { padding: "0 16px", margin: "calc(env(safe-area-inset-top) + 56px) 0px 64px", width: "calc(100% - 32px)" };

        if (bool) {
            return { padding: "16px", marginBottom: "0px", width: "calc(100% - 40px)" };
        } else {
            return { padding: "5px", marginBottom: "0px" };
        }
    }

    render() {
        if (!this.state.loading) {
            return (
                <div style={this.setContainer(isBrowser)} id="TargetDiv" className="aua-overflow">
                    <Typography className="homeDividerText" style={{padding: "8px 16px"}}>Inbox</Typography>

                    <div className="anchor aua-container" style={{margin: "8px 16px 32px;"}}>
                        <List aria-label="message-list">
                            {this.mapNotificationsToList(this.state.messages)}
                        </List>
                    </div>
                    
                    <CopyrightWidget 
                        begin={2012}
                        year={getThisYear()}
                        textAlign={'center'}
                        className="margin-top-16 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                    />
                </div>
            );
        } else {
            return (
                <LoadingCard text="Loading Messages..."/>
            );
        }
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details, messages } = state.auth;
    const { headerText, iconOne, iconTwo, backgroundcolor } = state.style;
    const { deckList } = state.decks;
    return {
        headerText,
        iconOne,
        iconTwo,
        backgroundcolor,
        deckList,
        auth_feedback,
        user_details,
        messages
    };
};

const NotificationsScreen = connect(mapStateToProps, { updateHeaderInfo, getLeaderboard, copyDeck, subscribeDeck, getUserDetails, updateNotification, getMessages })(
    withRouter(NotificationsClass)
);

export { NotificationsScreen };
